import { createSlice } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import { postIntroPage } from '../../apis/common'
import { updateReadIntroIds } from './commonPartSlice'
import { setErrors } from './errorsSlice'
import { IntroPages } from '../../types/common'

import { getPageId } from '../../../utils/introPage'

interface IntroPagesState {
  introPages: IntroPages
  isLoading: boolean
}

const initialState: IntroPagesState = {
  introPages: [],
  isLoading: true,
}

const introPageSlice = createSlice({
  name: 'introPage',
  initialState,
  reducers: {
    requestStart: (state: IntroPagesState) => {
      state.isLoading = true
      return state
    },
    createIntroPageSuccess: (state: IntroPagesState) => {
      state.isLoading = false
      return state
    },
    requestFailure: (state: IntroPagesState) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  createIntroPageSuccess,
  requestFailure,
} = introPageSlice.actions

export const introPageReducer = introPageSlice.reducer

export const createIntroPage = (
  path: string,
  callback: () => void,
): AppThunk => async (dispatch) => {
  const pageId = getPageId(path)
  if (!pageId) return
  requestStart()
  postIntroPage({ page_id: pageId })
    .then(() => {
      createIntroPageSuccess()
      dispatch(updateReadIntroIds(pageId))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
